/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



//////////////////
// WEBPACK FOOTER
// ../wheelhouse-core/~/lodash/_freeGlobal.js
// module id = 443
// module chunks = 0